import React, { ChangeEventHandler, useRef } from 'react';
import './MessageScriptTextArea.less';

export type MessageScriptTextAreaProps = {
  title?: React.ReactNode;
  value?: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  showTagFooter?: boolean;
};

const MessageScriptTextArea: React.FC<MessageScriptTextAreaProps> = ({ value = '', onChange, title, placeholder, showTagFooter = true }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleInsertNameTag = () => {
    const base = value || '';
    const needsSpace = base.length > 0 && !base.endsWith(' ');
    const newValue = `${base}${needsSpace ? ' ' : ''}/name`;

    if (onChange) {
      const event = {
        target: { value: newValue },
      } as unknown as React.ChangeEvent<HTMLTextAreaElement>;
      onChange(event);
    }

    textareaRef.current?.focus();
  };

  return (
    <div className="message-script-text-area">
      {title && <h3 className="message-script-text-area__title">{title}</h3>}
      <div className="message-script-text-area__wrapper">
        <textarea ref={textareaRef} className="message-script-text-area__input" value={value} onChange={onChange} placeholder={placeholder} rows={5} />
        {showTagFooter && (
          <div className="message-script-text-area__footer" onClick={handleInsertNameTag}>
            <span className="footer-text">Tag </span>
            <span className="footer-tag">/name</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageScriptTextArea;
